<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="employer-id grey">
                    ID {{ lead.id }}
                    <template v-if="!isNew">
                        ({{ lead.created_at }})
                    </template>
                </div>
                <div class="page-title bold fnt-lg dark text-left">
                    {{ lead.title }} ({{ lead.address }})
                </div>
                <div v-if="lead.duplicated_leads[0]">
                    Дубликаты Лидов:
                </div>
                <div v-for="duplicatedLead in lead.duplicated_leads" :key="duplicatedLead.id" class="text-left link" @click="goLead(duplicatedLead.id)">
                    {{ duplicatedLead.id }}, {{ duplicatedLead.title }},
                    обращение в офис {{ getOfficeNameById(duplicatedLead.office_id) }} {{ duplicatedLead.created_at }},
                    <span :class="{ red: duplicatedLead.status_id === 3 , green: duplicatedLead.status_id === 2 }">
                        {{ getStatusNameById(duplicatedLead.status_id) }}
                        <span v-if="duplicatedLead.status_id === 3 && duplicatedLead.refuse_reason">
                            ({{ duplicatedLead.refuse_reason.reference_refuse_reason.name }})
                        </span>
                        <span v-if="duplicatedLead.status_id === 2">
                            ({{ duplicatedLead.deal.status.name }})
                        </span>
                    </span>
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="save">
                    {{ saveBtnText }}
                </span>
                <span class="action-title action-close" @click="close">
                    Отменить
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="9" justify="start" class="pl15">
                <el-form :model="lead" label-position="top">
                    <div class="card-general card-view">
                        <el-row>
                            <el-col :span="3">
                                <div class="input-label">
                                    Статус
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="label-margin" v-html="statusName"></div>
                            </el-col>
                            <el-col :span="16" v-if="showActions">
                                <div class="label-margin">
                                    <div class="badge lead-target-bg pointer" @click="changeStatus(statusTarget)">
                                        Целевой
                                    </div>
                                    <div class="badge lead-not-target-bg pointer ml10" @click="changeStatus(statusNotTarget)">
                                        Не целевой
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mt10">
                            <el-col :span="24" :class="{ 'error-input': errors.lead_id }">
                                <div class="input-label">
                                    Канал связи
                                </div>
                                <el-select
                                    v-model="lead.link_id"
                                    filterable
                                    reserve-keyword
                                    size="mini"
                                    placeholder="Выберите канал связи"
                                >
                                    <el-option
                                        v-for="item in links"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    />
                                </el-select>
                                <div class="error" v-if="errors.lead_id">
                                    {{ errors.lead_id[0] }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mt10">
                            <el-col :span="24" :class="{ 'error-input': errors.title }">
                                <div class="input-label">
                                    Название
                                </div>
                                <el-input v-model="lead.title" size="mini" />
                                <div class="error" v-if="errors.title">
                                    {{ errors.title[0] }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mt10">
                            <el-col :span="24" :class="{ 'error-input': errors.address }">
                                <div class="input-label">
                                    Адрес
                                </div>
                                <address-autocomplete
                                    class="autocomplete-input"
                                    v-model="lead.address"
                                    dropdown-class="deal-address-dropdown"
                                    @handleCoordinates="handleCoordinates"
                                />
                                <div class="error" v-if="errors.address">
                                    {{ errors.address[0] }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-if="statusIsNotTarget">
                            <el-col :span="24">
                                <div class="input-label">
                                    Причина отказа
                                </div>
                                <el-select
                                    v-model="refuseReasonId"
                                    filterable
                                    reserve-keyword
                                    size="mini"
                                    placeholder="Выберите причину отказа"
                                >
                                    <el-option
                                        v-for="item in reasonsRefuse"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    />
                                </el-select>
                                <div class="error" v-if="errors.refuseReasonId">
                                    {{ errors.refuseReasonId[0] }}
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="input-label">
                                    Комментарий
                                </div>
                                <div>
                                    <el-input
                                        type="textarea"
                                        :autosize="{ minRows: 3, maxRows: 5}"
                                        placeholder=""
                                        v-model="notTargetReason"
                                    />
                                </div>
                                <div class="error" v-if="errors.notTargetReason">
                                    {{ errors.notTargetReason[0] }}
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="card-general card-view mt10">
                        <el-row>
                            <el-col :span="24" :class="{ 'error-input': errors.office_id }">
                                <div class="input-label">
                                    Офис
                                </div>
                                <el-select
                                    v-model="lead.office_id"
                                    filterable
                                    reserve-keyword
                                    size="mini"
                                    placeholder="Выберите офис"
                                    @change="changeOffice"
                                >
                                    <el-option
                                        v-for="item in offices"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    />
                                </el-select>
                                <div class="error" v-if="errors.office_id">
                                    {{ errors.office_id[0] }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" :class="{ 'error-input': errors.responsible_user_id }">
                                <div class="input-label">
                                    Ответственный
                                </div>
                                <el-select
                                    v-model="lead.responsible_user_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    filterable
                                    autocomplete
                                    placeholder="Выберите ответственного"
                                    size="mini"
                                >
                                    <el-option v-for="item in responsibleList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="error" v-if="errors.responsible_user_id">
                                    {{ errors.responsible_user_id[0] }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mb10">
                            <el-col :span="24">
                                <div class="input-label">
                                    Roistat
                                </div>
                                <template v-if="lead.link_id === localReferences.referenceLink.link_whatsapp && this.canEditRoistat">
                                    <el-input size="mini" autocomplete="off" type="text" v-model="lead.roistat_visit_id" />
                                    <div class="error" v-if="errors.roistatVisitId">
                                        {{ errors.roistatVisitId[0] }}
                                    </div>
                                    <span class="gray">
                                        нет roistat
                                    </span>
                                    <el-checkbox class="el-table-filter__checkbox-group" v-model="hasNoRoistat" />
                                </template>
                                <template v-else>
                                    {{ getRoistat }}
                                </template>
                            </el-col>
                        </el-row>
                        <el-row class="mb10">
                            <el-col :span="5">
                                <div class="input-label">
                                    Источник
                                </div>
                                <div>{{ lead.source }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <template v-if="!loading">
                        <contact
                            :contact="lead.contact"
                            :is-new="isNew"
                            @update-contact="updateContactId($event)"
                        />
                    </template>
                    <div v-if="lead.custom_fields !== undefined && lead.custom_fields.length > 0" class="card-general card-view mt10">
                        <div class="input-label">
                            Дополнительные поля
                        </div>
                        <div v-for="customField in lead.custom_fields" :key="customField.id">
                            <el-row>
                                <el-col :span="10">
                                    <span class="grey">
                                        {{ customField.name }}
                                    </span>
                                </el-col>
                                <el-col :span="14">
                                    {{ customField.value }}
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-form>
            </el-col>
            <el-col :span="15" :class="['ml15', { 'darken-lead-column': isDarkenColumn }]" style="width: 61%;">
                <tasks
                    :entity-id="this.id"
                    entity-type="lead"
                    @changeVisibility="darkenColumn"
                />
                <template v-if="loadEvent">
                    <events
                        entity-type="lead"
                        :entity-id="+id"
                        :entity="lead"
                        @changeVisibility="darkenColumn"
                    />
                </template>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Tasks from '@/components/Tasks';
import Events from '@/components/events/Events';
import Contact from '@/components/Contact';
import localReferences from '@/helpers/localReferences';
import RoleHelper from '@/helpers/roleHelper';
import '@/assets/styles/card.scss';
import AddressAutocomplete from '@/components/AddressAutocomplete';

library.add(faCheck);

export default {
    name: 'LeadCardEdit',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    components: {
        Events,
        Tasks,
        Contact,
        AddressAutocomplete
    },
    data() {
        return {
            lead: {
                id: null,
                contact_id: null,
                link_id: null,
                roistat_visit_id: '',
                address: '',
                coordinates: null,
                title: '',
                status: {
                    id: null,
                    name: ''
                },
                responsible_user_id: null,
                responsible_user: {
                    amo_crm_id: null,
                    comment: null,
                    created_at: null,
                    full_name: null,
                    icq: null,
                    id: null,
                    office_id: null,
                    phone: null,
                    position_id: null,
                    updated_at: null,
                    user_id: null
                }
            },
            employerOptions: [],
            loadingEmployer: false,
            contactOptions: [],
            loadingContact: false,
            loading: true,
            errors: {},
            list: [],
            isDarkenColumn: false,
            loadEvent: false,
            statusNew: 1,
            statusTarget: 2,
            statusNotTarget: 3,
            notTargetReason: null,
            refuseReasonId: null,
            hasNoRoistat: false,
            localReferences
        };
    },
    computed: {
        roles() {
            return this.$store.state.auth.roles;
        },
        responsibleList() {
            if (this.lead.office_id) {
                return this.$store.state.references.employersWithRoleLeadByOffice[this.lead.office_id];
            }
            return [];
        },
        leadName() {
            let name = '';
            if (this.lead.contact && this.lead.contact.name) {
                name += this.lead.contact.name;
            } else {
                name += 'Нет контакта';
            }
            if (this.lead.link && this.lead.link.name) {
                if (this.lead.link_id === localReferences.referenceLink.link_email) {
                    name += ' - письмо';
                    if (this.lead.contact && this.lead.contact.email) {
                        name += ' - ' + this.lead.contact.email;
                    }
                } else if (
                    this.lead.link_id === localReferences.referenceLink.link_call ||
                    this.lead.link_id === localReferences.referenceLink.link_missed_call
                ) {
                    name += ' - сделка';
                    if (this.lead.contact && this.lead.contact.contact_phones && this.lead.contact.contact_phones.length > 0) {
                        name += ' - ' + this.lead.contact.contact_phones[0].phone;
                    }
                } else {
                    name += ' - ' + this.lead.link.name;
                }
            }

            return name;
        },
        linkName() {
            return this.lead.link ? this.lead.link.name : null;
        },
        statusName() {
            if (!this.lead.status) {
                return;
            }
            let className = 'grey-dark';
            if (this.lead.status.id === this.statusNotTarget) {
                className = 'red';
            } else if (this.lead.status.id === this.statusTarget) {
                className = 'green';
            }
            const status = this.lead.status ? this.lead.status.name : null;
            return '<div class="bold ' + className + '">' + status + '</div>';
        },
        companies() {
            return this.$store.state.references.companies;
        },
        links() {
            return this.$store.state.references.links;
        },
        leadStatuses() {
            return this.$store.state.references.leadStatuses;
        },
        offices() {
            return this.$store.state.references.offices;
        },
        reasonsRefuse() {
            if (this.statusIsNotTarget) {
                return this.$store.state.references.reasonsRefuse.filter(reason => reason.status === localReferences.reasonsRefuse.status_not_target);
            }

            return this.$store.state.references.reasonsRefuse;
        },
        isNew() {
            return +this.id === 0;
        },
        saveBtnText() {
            return +this.id === 0 ? ' Создать ' : 'Применить';
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const approvedRoles = ['office_manager', 'head_office', 'right_setup'];
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        },
        canEditRoistat() {
            const roles = this.$store.state.auth.roles;
            let approvedRoles;
            if (this.isNew) {
                approvedRoles = ['lead_full_access', 'deal_financial_director', 'deal_ceo', 'deal_manager', 'lead_by_office'];
            } else {
                approvedRoles = ['lead_full_access', 'deal_financial_director', 'deal_ceo'];
            }

            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        },
        showActions() {
            return (!this.isNew && this.lead.status_id === this.statusNew) || Object.prototype.hasOwnProperty.call(this.roles, RoleHelper.lead_status_change.key);
        },
        statusIsTarget() {
            return this.lead.status_id === this.statusTarget;
        },
        statusIsNotTarget() {
            return this.lead.status_id === this.statusNotTarget;
        },
        getRoistat() {
            return this.lead.roistat_visit_id
                ? this.lead.roistat_visit_id
                : this.lead.roistat_marker;
        }
    },
    beforeMount() {
        if (this.isNew) {
            this.prepareNewLead();
        } else {
            this.getLead();
        }
    },
    methods: {
        async getLead() {
            await this.$store.dispatch('leads/getLead', this.id).then(
                response => {
                    this.loadEvent = true;
                    if (response.data.data.deal && response.data.data.deal.id) {
                        this.goDeal(response.data.data.deal.id);
                    }
                    this.lead = JSON.parse(JSON.stringify(response.data.data));
                    if (this.lead.refuse_reason) {
                        this.refuseReasonId = this.lead.refuse_reason.reason_id;
                        this.notTargetReason = this.lead.refuse_reason.comment;
                    }
                    if (this.lead.contact) {
                        this.contactOptions = [
                            {
                                id: this.lead.contact.id,
                                name: this.lead.contact.name
                            }
                        ];
                    }
                    if (this.lead.responsible_user) {
                        this.employerOptions = [
                            {
                                id: this.lead.responsible_user.id,
                                name: this.lead.responsible_user.full_name
                            }
                        ];
                    }
                    this.loading = false;
                },
                error => {
                    console.log(error);
                }
            );
        },
        prepareNewLead() {
            if (this.$route.params.leadId) {
                this.lead.lead_id = +this.$route.params.leadId;
            } else {
                this.lead = {
                    lead_id: null,
                    status_id: this.statusNew,
                    responsible_user_id: null,
                    status: {
                        id: this.statusNew,
                        name: 'Не обработан'
                    }
                };
            }
            this.loading = false;
        },
        searchEmployer(query) {
            if (!this.lead.office_id) {
                this.errors = {
                    responsible_user_id: ['Выберите офис']
                };
                return;
            }
            if (query !== '') {
                this.errors.responsible_user_id = null;
                this.loadingEmployer = true;
                this.$store.dispatch('employers/getEmployerByQuery', { query: query, office_id: this.lead.office_id }).then(
                    response => {
                        this.employerOptions = response.data.data.map(function(item) {
                            return { id: item.id, name: item.full_name };
                        });
                        this.loadingEmployer = false;
                    },
                    error => {
                        console.log(error);
                    }
                );
            }
        },
        changeOffice() {
            this.lead.responsible_user_id = null;
        },
        changeStatus(statusId) {
            this.lead.status_id = statusId;
            if (statusId === this.statusTarget) {
                this.lead.status.name = 'Целевой';
                this.save();
            } else if (statusId === this.statusNotTarget) {
                this.lead.status.name = 'Не целевой';
            }
        },
        save() {
            this.errors = {};
            if (
                this.lead.status_id === this.statusTarget ||
                this.lead.status_id === this.statusNew ||
                (
                    this.lead.status_id === this.statusNotTarget &&
                   ((this.notTargetReason !== null &&
                    this.notTargetReason.length > 0) &&
                    (this.refuseReasonId !== null))
                )) {
                if (this.lead.status_id === this.statusNew && this.lead.link_id === localReferences.referenceLink.link_whatsapp && !this.lead.roistat_visit_id && !this.hasNoRoistat) {
                    this.errors = {
                        roistatVisitId: [
                            'Заполните поле ROISTAT'
                        ]
                    };
                    return;
                }
                this.loading = true;
                const action = this.isNew ? 'createLead' : 'updateLead';
                if (this.notTargetReason && this.notTargetReason.length > 0 && this.refuseReasonId !== null) {
                    this.lead.notTargetReason = this.notTargetReason;
                    this.lead.refuseReasonId = this.refuseReasonId;
                }
                this.$store.dispatch('leads/' + action, this.lead).then(
                    response => {
                        this.loading = false;
                        if (response.data.success) {
                            if (response.data.data && (response.data.data.entityType === 'task' || response.data.data.entityType === 'deal')) {
                                this.$router.push({ name: response.data.data.entityType + '-card', params: { id: '' + response.data.data.entityId } });
                            } else {
                                this.$router.push({ name: 'lead-card-view', params: { id: '' + response.data.data.id } });
                            }
                        } else {
                            this.errors = response.data.data;
                        }
                    },
                    error => {
                        this.loading = false;
                        this.errors = error.response.data.errors;
                    }
                ).finally(() => { this.loading = false; });
            } else {
                this.errors = {
                    refuseReasonId: [
                        'Выберите причину из списка'
                    ],
                    notTargetReason: [
                        'Укажите комментарий'
                    ]
                };
            }
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'lead-card-view', params: { id: '' + this.id } });
            }
        },
        darkenColumn(value) {
            this.isDarkenColumn = value;
        },
        updateContactId(event) {
            this.lead.contact_id = event;
        },
        handleCoordinates(value) {
            this.lead.coordinates = value;
        },
        goDeal(id) {
            this.$router.push({ name: 'deal-card', params: { id: '' + id } });
        },
        goLead(id) {
            this.id = id;
            this.$router.push({ name: 'lead-card-view', params: { id: '' + id } });
            this.getLead();
        },
        getOfficeNameById(id) {
            if (!id) {
                return 'не указан';
            }
            return this.$store.getters['references/getOfficeNameById'].filter(item => item.id === id)[0].name;
        },
        getStatusNameById(statusId = null) {
            let status = '';
            if (statusId === this.statusNotTarget) {
                status = 'не целевой';
            } else if (statusId === this.statusTarget) {
                status = 'целевой';
            } else if (statusId === this.statusNew) {
                status = 'не обработан';
            }
            return status;
        }
    }
};
</script>
